import { render, staticRenderFns } from "./PetRanking.vue?vue&type=template&id=23ef2f04&scoped=true"
import script from "./PetRanking.vue?vue&type=script&lang=js"
export * from "./PetRanking.vue?vue&type=script&lang=js"
import style0 from "./PetRanking.vue?vue&type=style&index=0&id=23ef2f04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ef2f04",
  null
  
)

export default component.exports